import { MutableRefObject, useEffect, useRef } from "react"

/**
 * Returns the previous value passed to the hook
 */
export const usePrevious = <T>(value?: T): T | undefined => {
	const ref: MutableRefObject<T | undefined> = useRef<T | undefined>(undefined)
	useEffect(() => {
		ref.current = value
	}, [value])
	return ref.current
}
